import { Dialog, Icon, IconButton, Portal, Text } from '@chakra-ui/react';
import { LuX } from 'react-icons/lu';

import { handleDropdownAwareClose } from '@/utils/dropdownInteraction';

type DialogPlacement = Parameters<typeof Dialog.Root>[0]['placement'];

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title?: string | React.ReactNode;
  children: React.ReactNode;
  footer?: React.ReactNode;
  placement?: DialogPlacement;
  hideCloseButton?: boolean;
  maxWidth?: string;
}

const Modal = ({
  isOpen,
  onClose,
  title,
  children,
  footer,
  placement = 'center',
  hideCloseButton = false,
  maxWidth,
}: ModalProps) => {
  return (
    <Dialog.Root
      placement={placement}
      open={isOpen}
      onOpenChange={(e) => handleDropdownAwareClose(e.open, onClose)}
    >
      <Portal>
        <Dialog.Backdrop />
        <Dialog.Positioner>
          <Dialog.Content
            px={6}
            py={6}
            maxWidth={maxWidth}
            width={maxWidth ? '100%' : undefined}
            position="relative"
            maxHeight="90vh"
            display="flex"
            flexDirection="column"
          >
            {!hideCloseButton && (
              <IconButton
                variant="ghost"
                size="sm"
                position="absolute"
                top={4}
                right={4}
                onClick={onClose}
                aria-label="Close modal"
                _hover={{ backgroundColor: 'gray.100' }}
              >
                <Icon as={LuX} boxSize={5} color="gray.600" />
              </IconButton>
            )}
            {(title || !hideCloseButton) && (
              <Dialog.Header mb={title ? 5 : 0} flexShrink={0}>
                {title && (
                  <Text fontSize={24} fontWeight={500} color="fg">
                    {title}
                  </Text>
                )}
              </Dialog.Header>
            )}
            <Dialog.Body overflowY="auto" flex="1" minHeight={0}>{children}</Dialog.Body>
            {footer && <Dialog.Footer flexShrink={0}>{footer}</Dialog.Footer>}
          </Dialog.Content>
        </Dialog.Positioner>
      </Portal>
    </Dialog.Root>
  );
};

export default Modal;